import $ from 'jquery'
import { Turbo } from '@hotwired/turbo-rails'
import { Offcanvas, Tab, Tooltip } from 'bootstrap'

// Clickable table rows with link
// ---------------------------------------------------------------------

$(document).on('turbo:load', () => {
  $('.linkable-row').on('click', function() {
    Turbo.visit($(this).data('href'))
  })
})

// Highlight action_nav_link when its an anchor and active
// ---------------------------------------------------------------------

$(document).on('turbo:load', () => {
  $('.action_nav_link').each(function() {
    if ($(this).attr('href') === window.location.hash) {
      $(this).addClass('active')
    }
  })
})

// On scroll, highlight the action_nav_link for which the corresponding .action_nav_target is in view
$(document).on('turbo:load', () => {
  $(window).on('scroll', () => {
    const scrollPos = $(document).scrollTop()
    $('.action_nav_target').each(function() {
      if ($(this).offset().top <= scrollPos + 100) {
        const targetId = $(this).attr('id')
        $('.action_nav_link').removeClass('active')
        $('.action_nav_link[href="#' + targetId + '"]').addClass('active')
      }
    })
  })
})

// Horizontally scrolling tab bars
// ---------------------------------------------------------------------

// The section navigation and the tab bars scroll sideways on narrow screens,
// where the active tab is often out of sight. Bring it into view, centered.
const scrollActiveTabIntoView = (container) => {
  const active = container.querySelector('li.active > a, li.active, a.nav-link.active')
  if (!active) return
  const containerRect = container.getBoundingClientRect()
  const activeRect = active.getBoundingClientRect()
  if (activeRect.left >= containerRect.left && activeRect.right <= containerRect.right) return
  container.scrollLeft += (activeRect.left - containerRect.left) - (containerRect.width - activeRect.width) / 2
}

$(document).on('turbo:load', () => {
  document.querySelectorAll('#section_nav, .nav-tabs-scrollable').forEach((container) => {
    scrollActiveTabIntoView(container)
  })
})

// Off Canvas navigation
// ---------------------------------------------------------------------

// #page_sidenav is data-turbo-permanent, so the same element lives on from
// page to page. Anything bound to it on turbo:load has to unbind first (as
// below), or each visit adds another handler. The dropdown holding the active
// item is kept open in CSS (navigation.sass), and #toggle_sidenav is only
// rendered alongside the sidenav.

// Keep offcanvas push width in sync with actual sidenav width on mobile/tablet
const updateSidenavPushOffset = () => {
  const offcanvasEl = document.getElementById('page_sidenav')
  if (!offcanvasEl) return
  if (!window.matchMedia('(max-width: 991.98px)').matches) {
    document.documentElement.style.removeProperty('--page-sidenav-shift')
    const instance = Offcanvas.getInstance(offcanvasEl)
    if (instance) instance.hide()
    return
  }
  const open = offcanvasEl.classList.contains('show') ||
    offcanvasEl.classList.contains('showing') ||
    offcanvasEl.classList.contains('hiding')
  if (open) {
    document.documentElement.style.setProperty('--page-sidenav-shift', `${offcanvasEl.getBoundingClientRect().width}px`)
  } else {
    document.documentElement.style.removeProperty('--page-sidenav-shift')
  }
}

// Freeze the page behind the open mobile/tablet sidenav. Overflow:hidden on
// body is not enough on iOS: a swipe on the backdrop still moves the document
// unless those touch/wheel events are cancelled.
const sidenavBackgroundScrollLock = (event) => {
  const sidenav = document.getElementById('page_sidenav')
  if (sidenav && sidenav.contains(event.target)) return
  event.preventDefault()
}

const lockSidenavBackgroundScroll = () => {
  document.documentElement.classList.add('sidenav-open')
  document.addEventListener('touchmove', sidenavBackgroundScrollLock, { passive: false })
  document.addEventListener('wheel', sidenavBackgroundScrollLock, { passive: false })
}

const unlockSidenavBackgroundScroll = () => {
  document.documentElement.classList.remove('sidenav-open')
  document.removeEventListener('touchmove', sidenavBackgroundScrollLock)
  document.removeEventListener('wheel', sidenavBackgroundScrollLock)
}

// Snap the drawer shut without the Bootstrap hide animation. Needed before
// Turbo replaces <body> or caches the page: a snapshot taken mid-animation
// still has the drawer open and the page pushed aside.
const closeSidenavImmediately = () => {
  const offcanvasEl = document.getElementById('page_sidenav')
  if (!offcanvasEl) return
  const instance = Offcanvas.getInstance(offcanvasEl)
  if (instance) instance.dispose()
  offcanvasEl.classList.remove('show', 'showing', 'hiding')
  offcanvasEl.removeAttribute('aria-modal')
  offcanvasEl.removeAttribute('role')
  document.querySelectorAll('.offcanvas-backdrop').forEach((el) => el.remove())
  document.documentElement.style.removeProperty('--page-sidenav-shift')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')
  $('#toggle_sidenav .hamburger_button').addClass('collapsed')
  unlockSidenavBackgroundScroll()
}

// Toggle collapse button + mobile/tablet push behavior
$(document).on('turbo:load', () => {
  const offcanvas = $('#page_sidenav')
  if (!offcanvas.length) return

  updateSidenavPushOffset()

  $(window)
    .off('resize.sidenav-push')
    .on('resize.sidenav-push', updateSidenavPushOffset)

  offcanvas.off('show.bs.offcanvas.cgx hide.bs.offcanvas.cgx shown.bs.offcanvas.cgx hidden.bs.offcanvas.cgx')

  offcanvas.on('show.bs.offcanvas.cgx', () => {
    // .showing is added after this event, so set the push width explicitly.
    if (window.matchMedia('(max-width: 991.98px)').matches) {
      const offcanvasEl = document.getElementById('page_sidenav')
      document.documentElement.style.setProperty('--page-sidenav-shift', `${offcanvasEl.getBoundingClientRect().width}px`)
    }
    $('#toggle_sidenav .hamburger_button').removeClass('collapsed')
    lockSidenavBackgroundScroll()
  })

  offcanvas.on('hide.bs.offcanvas.cgx', () => {
    $('#toggle_sidenav .hamburger_button').addClass('collapsed')
  })

  offcanvas.on('hidden.bs.offcanvas.cgx', unlockSidenavBackgroundScroll)
})

// Hide offcanvas on sidenav click, so swiping back in iOS doesn't crap
// out the page. Close instantly — hide() would still be animating while
// Turbo swaps the page.
$(document).on('turbo:load', () => {
  const offcanvas = $('#page_sidenav')
  if (!offcanvas.length) return
  offcanvas.off('shown.bs.offcanvas.cgx')
  offcanvas.on('shown.bs.offcanvas.cgx', () => {
    offcanvas.find('a:not(.dropdown-toggle)')
      .off('click.sidenav-hide')
      .on('click.sidenav-hide', closeSidenavImmediately)
  })
})

$(document).on('turbo:before-cache', () => {
  closeSidenavImmediately()
  $('#flash_message').remove()
})

// Prevent links where Turbolinks is disabled or data-remote="true" to open new window in mobile Safari standalone Webapps (Homescreen links)
// https://gist.github.com/kylebarrow/1042026
// ---------------------------------------------------------------------

$(document).on('turbo:load', () => {
  // For iOS Web apps, so they do not open in new window
  if ('standalone' in window.navigator && window.navigator.standalone) {
    // If you want to prevent remote links in standalone web apps opening Mobile Safari, change 'remotes' to true
    const remotes = true
    document.addEventListener('click', (event) => {
      let link = event.target
      // Bubble up until we hit link or top HTML element. Warning: BODY element is not compulsory so better to stop on HTML
      while (link.nodeName !== 'A' && link.nodeName !== 'HTML') {
        link = link.parentNode
      }
      if ('href' in link && link.href.indexOf('http') !== -1 && (link.href.indexOf(document.location.host) !== -1 || remotes) && event.target.constructor.name !== 'HTMLAnchorElement') {
        event.preventDefault()
        // do not redirect page on data-remote links
        if ($(link).data('remote') !== true) document.location.href = link.href
      }
    })
  }
})

// Tooltips
// ---------------------------------------------------------------------

$(document).on('turbo:load', () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => new Tooltip(el))
})

// Filter search
// ---------------------------------------------------------------------

// Sets the filter search button active
$(document).on('turbo:load', () => {
  if ($('#filter_search').hasClass('in')) {
    $("[aria-controls='filter_search']").addClass('active')
  }
})

// Sets the filter search button active
$(document).on('turbo:load', () => {
  $('#filter_search').on('show.bs.collapse', () => {
    $("[aria-controls='filter_search']").addClass('active')
  })
  $('#filter_search').on('hide.bs.collapse', () => {
    $("[aria-controls='filter_search']").removeClass('active')
  })
})

// Enable Organization switching inside modal
// ---------------------------------------------------------------------

const organizationSwitcherSkeleton = () => {
  const template = document.getElementById('organization_switcher_skeleton')
  if (template) return template.innerHTML
  return '<div class="async_loader"></div>'
}

const scrollActiveOrganizationIntoView = () => {
  const body = document.querySelector('#main_modal .modal-body')
  if (!body) return
  const active = body.querySelector('.organization_selector li.active')
  if (!active) return
  body.scrollTop += active.getBoundingClientRect().top - body.getBoundingClientRect().top - (body.clientHeight / 2) + (active.offsetHeight / 2)
}

const visibleOrganizationSwitcherLinks = () => $('#main_modal .organization_selector li:visible a')

const clearOrganizationSwitcherKeyboardSelection = () => {
  $('#main_modal .organization_selector li').removeClass('keyboard-selected')
}

const markOrganizationSwitcherKeyboardSelection = (link) => {
  clearOrganizationSwitcherKeyboardSelection()
  if (link) $(link).closest('li').addClass('keyboard-selected')
}

const focusOrganizationSwitcherLink = (link) => {
  if (!link) return
  markOrganizationSwitcherKeyboardSelection(link)
  link.focus()
  link.scrollIntoView({ block: 'nearest' })
}

// Tab from the live-search field selects the first visible org; further Tab /
// Shift+Tab moves through the visible list and back to the search field.
const navigateOrganizationSwitcher = (event) => {
  if (!(event.key === 'Tab' || event.keyCode === 9)) return

  const links = visibleOrganizationSwitcherLinks()
  if (!links.length) return

  const searchField = $('#organization-list-search')
  const searchFocused = searchField.is(':focus')
  const focusedLink = $(event.target).closest('.organization_selector a')
  const currentIndex = focusedLink.length ? links.index(focusedLink) : -1

  if (event.shiftKey) {
    if (searchFocused || currentIndex < 0) return
    event.preventDefault()
    if (currentIndex === 0) {
      clearOrganizationSwitcherKeyboardSelection()
      searchField.trigger('focus')
    } else {
      focusOrganizationSwitcherLink(links.get(currentIndex - 1))
    }
    return
  }

  if (searchFocused) {
    event.preventDefault()
    focusOrganizationSwitcherLink(links.get(0))
    return
  }

  if (currentIndex < 0 || currentIndex >= links.length - 1) return
  event.preventDefault()
  focusOrganizationSwitcherLink(links.get(currentIndex + 1))
}

// #main_modal itself is rendered with the switcher and reinserted by
// main-modal.js. Creating it here, on turbo:load, was too late: Bootstrap's
// modal Data API runs in the capture phase and throws if the shell is missing.

$(document).on('show.bs.modal', '#main_modal', function(event) {
  const modal = $(this)
  const button = event.relatedTarget
  if (!button) return

  const title = button.getAttribute('data-modal-title') || $(button).text().trim()
  modal.find('.modal-title').text(title)
  modal.find('.modal-body').attr('aria-busy', 'true').html(organizationSwitcherSkeleton())

  modal.find('.modal-body').load(button.href + '?modal_layout=true', (response, status) => {
    modal.find('.modal-body').removeAttr('aria-busy')
    if (status !== 'success') return
    const heading = $(response).find('h1').first().text()
    if (heading) modal.find('.modal-title').text(heading)
    scrollActiveOrganizationIntoView()
  })
})

// Asynchronous content loader
// ---------------------------------------------------------------------
$(document).on('turbo:load', () => {
  $('#page_content').on('submit', 'form.async', () => {
    $('.async_content').html('<div class="async_loader"></div>')
    $('.async_content').fadeIn(50)
  })
})

// Add active class to card headings
// ---------------------------------------------------------------------

$(document).on('turbo:load', () => {
  $('.card-collapse').on('show.bs.collapse', function() {
    $(this).siblings('.card-header').addClass('active')
  })
  $('.card-collapse').on('hide.bs.collapse', function() {
    $(this).siblings('.card-header').removeClass('active')
  })
})

// Hide flash after x seconds
// ---------------------------------------------------------------------

let flashTimer = null

$(document).on('turbo:load', () => {
  if (flashTimer) clearTimeout(flashTimer)
  const flash = $('#flash_message')
  if (flash.length) {
    flashTimer = setTimeout(() => {
      flash.removeClass('animate__fadeInDown').addClass('animate__fadeOutUp')
      flashTimer = null
    }, 5000)
  }
})

$(document).on('turbo:load', () => {
  $('#flash_message button.btn-close').on('click', function() {
    if (flashTimer) clearTimeout(flashTimer)
    flashTimer = null
    $(this).parent().removeClass('animate__fadeInDown').addClass('animate__fadeOutUp')
  })
})

// Deep linking for Tabs
// ---------------------------------------------------------------------

$(document).on('turbo:load', () => {
  let url = window.location.href.replace(/\/$/, '')
  if (window.location.hash) {
    const hash = url.split('#')
    const tabEl = document.querySelector('#linkableTabs a[href="#' + hash[1] + '"]')
    if (tabEl) new Tab(tabEl).show()
    url = window.location.href.replace(/\/#/, '#')
    window.history.replaceState(null, null, url)
  }
  $('a[data-bs-toggle="tab"]').on('click', function() {
    const hash = $(this).attr('href')
    const newUrl = (hash === '#home' ? url.split('#')[0] : url.split('#')[0] + hash) + '/'
    window.history.replaceState(null, null, newUrl)
  })
})

// Organization list search field
// ---------------------------------------------------------------------

// Use MutationObserver to reliably detect when search field appears in modal
// This works regardless of loading speed (slow networks, busy devices)
$(document).on('shown.bs.modal', '#main_modal', () => {
  const modalBody = document.querySelector('#main_modal .modal-body')
  if (!modalBody) return

  // Function to bind search field events
  const bindSearchField = () => {
    const searchField = $('#organization-list-search')
    if (!(searchField.length > 0)) return false
    if (searchField.data('org-search-bound')) return true
    searchField.data('org-search-bound', true)

    // Focus search field by pressing 'f'; Tab walks visible organizations
    $(document).on('keydown.orgSearch', (e) => {
      navigateOrganizationSwitcher(e)
      if (e.keyCode === 70 && !searchField.is(':focus') && !$(e.target).is('input, textarea, select')) {
        searchField.trigger('focus')
        e.preventDefault()
      }
    })

    $(document).on('focusin.orgSearch', '#main_modal', (e) => {
      clearOrganizationSwitcherKeyboardSelection()
      $(e.target).closest('.organization_selector li').addClass('keyboard-selected')
    })

    // Handle search form input (use namespaced event)
    searchField.on('input.orgSearch', (e) => {
      const searchTerm = e.target.value.toUpperCase()
      // Handle each list element
      $('.organization_selector li').each(function() {
        const organizationName = $(this).find('.nameing').text().toUpperCase()
        $(this).toggle(organizationName.includes(searchTerm))
      })
      const selected = $('#main_modal .organization_selector li.keyboard-selected')
      if (selected.length && !selected.is(':visible')) {
        selected.removeClass('keyboard-selected')
        searchField.trigger('focus')
      }
    })

    return true // Signal success
  }

  // Check if search field already exists (might load instantly)
  if (bindSearchField()) return

  // Otherwise, observe DOM changes until search field appears
  const observer = new MutationObserver(() => {
    if (bindSearchField()) observer.disconnect() // Stop observing once found
  })

  // Watch for child elements being added to modal body
  observer.observe(modalBody, { childList: true, subtree: true })

  // Cleanup observer if modal closes before search field appears
  $(document).one('hidden.bs.modal', '#main_modal', () => {
    observer.disconnect()
  })
})

// Clean up event handlers when the modal is hidden (use namespaced events)
$(document).on('hidden.bs.modal', '#main_modal', (e) => {
  $(document).off('keydown.orgSearch focusin.orgSearch')
  $('#organization-list-search').off('input.orgSearch')
  const modal = $(e.currentTarget)
  modal.find('.modal-title').empty()
  modal.find('.modal-body').empty().removeAttr('aria-busy')
})

// Rating (stars)
// See rating_helper.rb
// ---------------------------------------------------------------------

$(document).on('turbo:load', () => {
  $('.rating.form').each(function() {
    const ratingFormId = '#' + $(this).attr('id')
    const ratingStarSelector = ratingFormId + ' .rating_star'

    $(ratingStarSelector).on('mouseenter', function() {
      $(this).prevAll().addClass('full')
      $(this).nextAll().removeClass('full')
    }).on('mouseleave', () => {
      if ($(ratingStarSelector + ':checked').length > 0) {
        $(ratingStarSelector + ':checked').prevAll().addClass('full')
        $(ratingStarSelector + ':checked').nextAll().removeClass('full')
      } else {
        $(ratingStarSelector).removeClass('full')
      }
    })

    $(ratingStarSelector).on('click', function() {
      $(this).prevAll().addClass('full')
      $(this).nextAll().removeClass('full')
    })
  })
})

// Empty a timeframe's selects (FormsHelper#timeframe)
// ---------------------------------------------------------------------

$(document).on('click', '.timeframe-reset', function() {
  $(this).closest('.timeframe').find('select').val('')
})

// The approval ladder follows the budgets as they are typed
// (settings/ticket_settings/edit)
// ---------------------------------------------------------------------

$(document).on('input', '[data-approval-budget]', function() {
  $(`[data-approval-amount="${this.dataset.approvalBudget}"]`).text(this.value)
})
